import { Component, OnInit, Inject } from "@angular/core";
import { DataService, Response } from "../../dataService/data.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalVariable } from "../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-review-experience-layout",
  templateUrl: "./review-experience-layout.component.html",
  styleUrls: ["./review-experience-layout.component.scss"],
})
export class ReviewExperienceLayoutComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  slug_value: String;
  feed_back: boolean;
  show_module: boolean = false;
  show_page: String;
  public loading = false;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private spinner: NgxUiLoaderService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private commonservice: CommonService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.commonservice.show_review_page.subscribe((show_page) => {
      this.show_page = show_page;
      if (this.show_page === "YES") {
        this.feed_back = true;
        this.show_module = true;
      } else {
        let res: Response;
        this.route.params.forEach((val) => {
          this.slug_value = val["id"];
        });
        const json_data = {
          slug: this.slug_value,
        };
        // const data_service = this.HttpService.postjson(this.BASE_URL.SMS_FEEDBACK_URL, json_data);
        // data_service.subscribe((data: Response) => {
        //   res = data;
        // }, error => {

        // }, () => {
        //   this.feed_back = res.data['has_feedback'];
        //   // this.feed_back = true;
        //   this.show_module = true;
        // });
      }
    });
  }
}
